
function ScorecardHistoryBaseController(config, history) {
    var vm = this;

    vm.config = config;
    vm.history = history;
    vm.overviewQuestions = ['fiscal_year_end', 'total_liabilities',
                            'total_assets', 'cash_on_hand', 'operating_expenses',
                            'line_of_credit', 'credit_in_use'];

}

module
    .controller('ScorecardHistoryBaseController',ScorecardHistoryBaseController)
